import { createQuestionValueMap, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, createFieldsGroups, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

const defaultItems: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Ocupación", fontWeight: "bold" }],
    ["dd478d98-b7f5-4a26-932a-c29de6aebf0f", {}],
    ["c2f5ae4d-d558-4acc-8cfa-349cbd25663c", {}],
    ["7ad84f6e-be8f-4e13-a489-ba71e558b6eb", {}],
    ["d48bef3d-30b6-4f07-897e-2ecc7013a0ad", {}],
    ["45a0d00f-3a1a-4a79-8940-5328ef07a6b4", { showBorder: true }],
]);

const defaultItems_2: Map<string, ConfirmationData> = new Map([
    ["c244be34-e040-4744-9f06-d3d2ee24f07b", { fontWeight: "bold" }],
    ["dfed184f-2b4e-44c8-a50e-5d4207ba6657|9f4da035-5cf0-437b-97cd-3cd4b904a312", { label: "Sí/No" }],
]);

const items = createFieldsGroups([], defaultItems);

export const defaultOccupationInformation: Map<string, ConfirmationData> = new Map([
    ...items
]);

export const updateOccupationInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const section = page.sections.find(section => section.section_id === "9cfb571b-64aa-440e-b318-f4f20ec108fc");
    if (!section) {
        return cd;
    }
    const groups = section.groups.filter(group => group.group_id !== "05a3b9c6-968a-492b-86fe-0cb68ab2775f").sort((a, b) => a.order - b.order);
    const updatedItems = createFieldsGroups(groups, defaultItems);

    const answersMap = createQuestionValueMap(page);
    cd = new Map([...cd, ...updatedItems]);
    cd = new Map([...cd, ...defaultItems_2]);
    return updateMapWithFields(mapToTupleArray(answersMap), cd);
}